import { Component, OnInit, ViewChild, Output, Input, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import data from '../../../app/project.json';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['../styles/app-footer.styles.less']
})
export class AppFooterComponent implements OnInit {
  @Input() isOrdering: boolean;
  isProd: boolean;
  version: string;

  constructor( private router: Router) {
  }

  ngOnInit() {
    if (environment.production) {
      this.isProd = true;
    }
    this.version = data.version;
  }

  redirectToBenifit() {
    this.router.navigate(['/benefits']);
  }

  redirectTo(uri:string) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.router.navigate([uri]));
    window.scrollTo({top:0,left:0,behavior:'smooth'});
   
  }
}
